// extracted by mini-css-extract-plugin
export default {"results_footer":"a8","hide_img":"b8","img":"c8","copy_wrapper":"e8","grid":"f8","grid_item":"g8"};
    if(module.hot) {
      // 1713912568004
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  